module.exports = __webpack_public_path__ + "static/media/230x0w_1.65610d24.png";